module.exports = __webpack_public_path__ + "static/media/010.9f1a090e.jpg";